import { Row, Col } from "react-bootstrap"

import { Item, chooseHeader } from "../../Item"
import Resume from "../../Resume"

import * as S from "./styled"

const Order = ({ order, titles, user }) => (
  <S.Card>
    <Row noGutters className="w-100 mb-1 mr-4">
      <S.Header>
        <S.Title>{titles[order.type]}</S.Title>
        <S.Divider className="mr-2" />
      </S.Header>
    </Row>
    <Row noGutters>
      <Col xs={12} lg={8} className="px-2 px-sm-3 px-md-4">
        <S.Details className="w-100">
          {chooseHeader(order.type)}
          {order.itens.map((item) => (
            <Item
              key={`${order.type}${item.OS}}`}
              type={order.type}
              item={item}
              user={user}
              orderId={order.orderId}
            />
          ))}
        </S.Details>
      </Col>

      <Resume order={order} user={user} />
    </Row>
  </S.Card>
)

export default function Layout({ orders, user }) {
  const titles = {
    parapar: "Par a Par",
    surfacado: "Surfaçado",
    grade: "Grade",
  }

  const layoutProps = {
    orders,
    user,
    titles,
  }

  return orders.map((order) => <Order {...{ order, key: order.type, ...layoutProps }} />)
}
